import {ShippingOption} from "../../../Apis/Models/IOrderDto";
import {useTranslation} from "react-i18next";
import {useMemo} from "react";

interface ShippingOptionsWithLabel {
    value: string | undefined;
    label: string;
}
export const useShippingOptions = (): {shippingOptions: ShippingOptionsWithLabel[], getShippingOptionLabel: (shippingOption: ShippingOption) => string} => {

    const { t } = useTranslation();

    const shippingOptions = useMemo(() => [
        { value: 'Pickup', label: t('shippingOption.Pickup')},
        { value: 'Delivery', label: t('shippingOption.Delivery')},
        { value: 'Storage', label: t('shippingOption.Storage') },
    ], [t]);

    const getShippingOptionLabel = (shippingOption: ShippingOption): string => {
        return shippingOptions.find(x => x.value === shippingOption)?.label ?? '';
    }

    return { shippingOptions, getShippingOptionLabel };

}
